export const showNotification = (type, message, duration = 5000) => {
  const event = new CustomEvent('show-notification', {
    detail: { type, message, duration }
  });

  window.dispatchEvent(event);
};
